import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;
